// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "f8aea8791b2c1fa4e1bde830b985dc61a9eaa9ff",
  version: "1.122.2",
};
